export const LABEL_TIPO_DESPACHO = {
  ENVIO: 'Envío',
  RETIRO: 'Retiro por cliente',
  COORD_CLIENTE: 'Coordinado por cliente',
  ON_SITE: 'On Site',
}
